import StudentRIASEC from './StudentRIASEC';

export default StudentRIASEC;
